import {
  FieldCheckbox as LookerFieldCheckbox,
  type FieldCheckboxProps as LookerFieldCheckboxProps,
} from '@looker/components';

import { cls } from '@/utils/cls';

import style from './styles.module.scss';

export type FieldCheckboxProps = LookerFieldCheckboxProps;

export function FieldCheckbox({ className, ...props }: FieldCheckboxProps) {
  return (
    <LookerFieldCheckbox
      className={cls(style.fieldCheckbox, className)}
      {...props}
    />
  );
}
